import { SectorModel } from '../service/sector.model';

import { Component, OnInit, ViewEncapsulation, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { DBConnectorService } from '../service/test.service';
import { Subscription } from 'rxjs';
import { AppComponent } from '../app.component';
import { HttpClient } from '@angular/common/http';

declare let d3: any;
// const host = 'http://localhost:5000/';
const apiEndPoint = 'api/MODEL_ACCURACY/GetMODEL_ACCURACY';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css', '../../../node_modules/nvd3/build/nv.d3.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit, OnDestroy {
  sectormodel = new SectorModel;
  options;
  data;
  months;
  total_records = 0;
  total_categories = 0;
  public result_data: any = {};
  urldata: any = {};
  accuracyOverviews;
  getcommandjson: any = {};
  Admin = false;
  RoleId = '';
  Sub: Subscription;

  constructor(private testService: DBConnectorService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef) {

    this.sectormodel.SectorName = this.testService.SectorName;
    this.sectormodel.ModelName = this.testService.ModelName;
    this.Admin = this.testService.Admin;
    this.testService.onGetSec.subscribe((res) => { this.sectormodel.SectorName = res; });
    // this.Sub = this.testService.onGetMod.subscribe((res) => { this.sectormodel.ModelName = res; this.graphFunction(); });
  }

  graphFunction() {
    this.total_categories = 0;
    this.total_records = 0;
    this.http.get<any>(apiEndPoint + '?Sector=' + this.sectormodel.SectorName + '&Model=' + this.sectormodel.ModelName)
      
      .subscribe((result) => {
        // console.log('home.component.ts: line 385: JSON.stringify(result) ' + JSON.stringify(result));
        this.urldata = result;
        // console.log('home.component.ts: line 385: JSON.stringify(this.urldata) ' + JSON.stringify(this.urldata));

        const slice_top_limit = 10;
        this.accuracyOverviews = result['accuracyOverview']; // .slice(1, slice_top_limit);
        // console.log('home.component.ts: line 37 : accuracyOverviews ' + this.accuracyOverviews);
        const values1 = [];
        const values2 = [];
        for (const entry of this.accuracyOverviews) {

          this.total_categories += 1;
          let labelValue = {};
          labelValue['x'] = entry.category;
          labelValue['y'] = +entry.recordsPredicted;
          this.total_records += +entry.recordsPredicted;

          values1.push(labelValue);

          labelValue = {};
          labelValue['x'] = entry.category;
          labelValue['y'] = +entry.recordsNotPredicted;
          this.total_records += +entry.recordsNotPredicted;
          values2.push(labelValue);
        }

        const _array = [];
        let _dict = {};
        _dict['key'] = 'Accurate Predictions';
        _dict['color'] = '#00a3ae';
        _dict['values'] = values1;
        _array.push(_dict);

        _dict = {};
        _dict['key'] = 'Wrong Predictions';
        _dict['color'] = '#7fd1d6';
        _dict['values'] = values2;
        _array.push(_dict);

        // console.log('home.component.ts: line 419: _array ' + JSON.stringify(_array));
        this.data = _array;

        this.options = {
          'chart': {
            'type': 'multiBarChart',
            'height': 450,
            'margin': {
              'top': 40,
              'right': 20,
              'bottom': 100,
              'left': 45
            },
            'reduceXTicks': false,
            'clipEdge': true,
            'duration': 500,
            'stacked': true,
            'xAxis': {
              'rotateLabels': -30,
              'showMaxMin': false
            },
            'yAxis': {

              'axisLabelDistance': -20
            }
          }
        };


      }
      );
  }

  ngOnInit() {
    this.RoleId = this.testService.RoleID;
    this.cdr.detectChanges();

    this.testService.onGetSec.subscribe((res) => { this.sectormodel.SectorName = res; });
    this.Sub = this.testService.onGetMod.subscribe((res) => { this.sectormodel.ModelName = res; this.graphFunction(); });

    this.graphFunction();
  }

  ngOnDestroy() {
    this.Sub.unsubscribe();
  }

}
